import { faFacebook, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import Button from '../button'
import IconButton from '../button/icon'
import NavLink from './link'
import { Link, useLocation } from 'react-router-dom'
import { faEnvelope, faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
import { useState, useEffect, useContext } from 'react'
import { createClient } from '@sanity/client'
import { fetchSiteConfigData } from '../../api'
import { toast } from 'react-toastify'
import COPY from '../../utils/copy'
import { slide as Menu } from 'react-burger-menu'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import WindowWidthContext from '../../context/window'

export default function Navbar() {
  const windowWidth = useContext(WindowWidthContext)

  const [isLoading, setIsLoading] = useState(true)
  const [siteConfigData, setSiteConfigData] = useState<{
    facebook: string
    instagram: string
    whatsapp: string
    calendly: string
    email: string
    businessName: string
    logoUrl: string
  } | null>(null)
  const [burgerIsOpen, setIsOpenBurger] = useState(false)

  useEffect(() => {
    const client = createClient({
      projectId: COPY.SANITY_PROJECT_ID,
      dataset: COPY.SANITY_DATASET,
      apiVersion: COPY.SANITY_API_VERSION,
      useCdn: true,
    })

    client
      .fetch(fetchSiteConfigData)
      .then((data) => {
        setSiteConfigData(data)
      })
      .catch((error) =>
        toast.error(error, {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        }),
      )
    setIsLoading(false)
  }, [])

  function toggleBurger() {
    if (burgerIsOpen) {
      setIsOpenBurger(false)
    }
    if (!burgerIsOpen) {
      setIsOpenBurger(true)
    }
  }

  const location = useLocation()
  const isHomepage = location.pathname === COPY.HOME_URL
  const isContactPage = location.pathname === COPY.CONTACT_URL
  const isPrivacyPage = location.pathname === COPY.PRIVACY_URL
  const isTermsPage = location.pathname === COPY.TERMS_URL
  const isCookiesPage = location.pathname === COPY.COOKIES_URL

  return (
    <>
      <div className='sticky top-0 left-0 w-full h-12 sm:h-20 bg-white shadow-xl flex flex-row justify-between sm:justify-evenly items-center z-50'>
        <div className='flex flex-row items-center h-20'>
          <Link to={COPY.HOME_URL}>
            <img
              src={isLoading ? '' : siteConfigData?.logoUrl}
              alt={COPY.LOGO_ALT}
              height={48}
              width={259}
            />
          </Link>
        </div>
        <div className='hidden sm:flex flex-row items-center h-20'>
          {!isHomepage && !isContactPage && (
            <NavLink link={COPY.HOME_URL} content={COPY.HOME} className='text-lg' />
          )}
          {isHomepage && <NavLink link={COPY.VISAS_URL} content={COPY.VISAS} className='text-lg' />}
          {isHomepage && (
            <NavLink link={COPY.SERVICES_URL} content={COPY.SERVICES} className='text-lg' />
          )}
          {isHomepage && <NavLink link={COPY.FAQ_URL} content={COPY.FAQ} className='text-lg' />}
          {isHomepage && <NavLink link={COPY.ABOUT_URL} content={COPY.ABOUT} className='text-lg' />}
          {!isContactPage && (
            <NavLink link={COPY.CONTACT_URL} content={COPY.CONTACT} className='text-lg' />
          )}
        </div>
        <div className='flex flex-row items-center h-20 w-auto'>
          {windowWidth && windowWidth > 900 && (
            <>
              <IconButton
                icon={faWhatsapp}
                className='text-white'
                link={isLoading ? '#' : siteConfigData?.whatsapp}
              />
              <IconButton
                icon={faInstagram}
                className='text-white'
                link={isLoading ? '#' : siteConfigData?.instagram}
              />
              <IconButton
                icon={faFacebook}
                className='text-white'
                link={isLoading ? '#' : siteConfigData?.facebook}
              />
              <IconButton
                icon={faEnvelope}
                className='text-white'
                link={isLoading ? '#' : 'mailto:' + siteConfigData?.email}
              />
            </>
          )}
        </div>
        <div className='flex flex-row items-center h-20 w-auto'>
          {windowWidth && windowWidth > 1200 && (
            <Button
              content={COPY.SCHEDULE_A_CALL}
              link={isLoading ? '#' : siteConfigData?.calendly}
            />
          )}
        </div>
        <div className='flex flex-row items-center h-20 sm:hidden' onClick={toggleBurger}>
          <FontAwesomeIcon
            icon={burgerIsOpen ? faTimes : faBars}
            size={'lg'}
            className='sm:hidden pr-6'
          />
        </div>
      </div>
      <Menu
        right
        width={'fit-content'}
        isOpen={burgerIsOpen}
        customBurgerIcon={false}
        customCrossIcon={false}
        styles={{
          bmBurgerButton: {
            display: 'none',
          },
          bmCrossButton: {
            display: 'none',
          },
        }}
      >
        <div className='bg-white border-l-4 border-gray-200 flex flex-col items-center justify-center w-100% py-12 h-full'>
          <div className='flex flex-col items-center justify-start px-6'>
            {!isHomepage && <NavLink content={COPY.HOME} link={COPY.HOME_URL} className='mb-2' />}
            <div onClick={toggleBurger}>
              {isHomepage && (
                <NavLink link={COPY.VISAS_URL} content={COPY.VISAS} className='mb-2' />
              )}
            </div>
            <div onClick={toggleBurger}>
              {isHomepage && (
                <NavLink link={COPY.SERVICES_URL} content={COPY.SERVICES} className='mb-2' />
              )}
            </div>
            <div onClick={toggleBurger}>
              {isHomepage && <NavLink link={COPY.FAQ_URL} content={COPY.FAQ} className='mb-2' />}
            </div>
            <div onClick={toggleBurger}>
              {isHomepage && (
                <NavLink link={COPY.ABOUT_URL} content={COPY.ABOUT} className='mb-2' />
              )}
            </div>
            {!isContactPage && (
              <NavLink content={COPY.CONTACT} link={COPY.CONTACT_URL} className='mb-2' />
            )}
            {!isPrivacyPage && (
              <NavLink content={COPY.PRIVACY} link={COPY.PRIVACY_URL} className='mb-2' />
            )}
            {!isTermsPage && (
              <NavLink content={COPY.TERMS} link={COPY.TERMS_URL} className='mb-2' />
            )}
            {!isCookiesPage && (
              <NavLink content={COPY.COOKIES} link={COPY.COOKIES_URL} className='mb-2' />
            )}
          </div>
        </div>
      </Menu>
    </>
  )
}
